import React from "react";

const Contact = () => {
  return (
    <div className="contact">
      <h2>Contact Us</h2>
      <p>If you have any questions, feel free to reach out to us!</p>
      <p>Email: contact@gourmethaven.com</p>
      <p>Phone: (123) 456-7890</p>
      {/* Optionally, add a contact form */}
    </div>
  );
};

export default Contact;